import Api from './Api';

class AcordaoApi extends Api {
    async transferirAcordao(idSessao, processos) {
        return this.fetch(
            this.configuracao.urlSessoes + idSessao + '/transferir-acordaos/',
            'POST',
            processos
        );
    }

    async validarAcordao(idSessao, numeroProcesso, validado) {
        return this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/acordao/validado',
            'PUT',
            validado.toString(),
            [{ parametro: 'Content-type', valor: 'text/plain' }]
        );
    }

    async marcarAcordaoObrigatorio(idSessao, numeroProcesso, acordaoObrigatorio) {
        return this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/marcador-acordao-obrigatorio',
            'PUT',
            acordaoObrigatorio.toString(),
            [{ parametro: 'Content-type', valor: 'text/plain' }]
        );
    }

    async devolverAcordao(idSessao, numeroProcesso, observacao) {
        let result;
        let url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/devolver-acordao-invalido`;

        result = await this.fetch(url, 'POST', observacao, [{ parametro: 'Content-type', valor: 'text/plain' }]);
        return result;
    }
}

export default AcordaoApi;
